module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/hu-card-drag.ac298aeafbe52203ffb7.gif";